// バージョンゲートの判定ロジック(純関数)。firebaseに依存しないためJestで直接テストできる。

// ローカル開発(localhost等)ではゲートを無効にする。
// 開発サーバのビルドIDで本番のバージョンdocを進めたり、開発中のタブが
// ブロックされたりするのを防ぐため、本番ホスト以外では購読・更新・検査を行わない。
export const isLocalHostname = (hostname) =>
  hostname === "localhost" ||
  hostname === "[::1]" ||
  /^127(\.\d{1,3}){3}$/.test(hostname);

export const shouldEnforceVersionGate = (hostname) => !isLocalHostname(hostname);

// サーバ側のbuild_idが自分のビルドより新しいか。
// 値が欠けている・数値でない場合はfalse(=誤ってブロックしない側に倒す。
// 旧ビルドの遮断はfirestore.rulesのサーバ側ガードが最終防衛する)。
export const isNewerBuildAvailable = (serverBuildId, localBuildId) =>
  Number(serverBuildId) > Number(localBuildId);

// 自分のビルドの方が新しいときだけバージョンdocを進めてよい(前方単調)。
// docが未作成(serverBuildId == null)なら作成する。
export const shouldSelfBump = (serverBuildId, localBuildId) =>
  Number(localBuildId) > 0 &&
  (serverBuildId == null || Number(localBuildId) > Number(serverBuildId));

// タブ復帰・フォーカス等のイベント駆動の再確認を間引く最小間隔
export const RECHECK_MIN_INTERVAL_MS = 15000;

export const shouldRecheckNow = (
  nowMs,
  lastCheckedMs,
  minIntervalMs = RECHECK_MIN_INTERVAL_MS
) => lastCheckedMs == null || nowMs - lastCheckedMs >= minIntervalMs;
